var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description)?_c('div',{staticClass:"c-disclaimer"},[_c('div',{staticClass:"l-container"},[(_vm.description)?_c('wysiwyg',{attrs:{"html":"description"}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }